import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { postanextblog  } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class Addblog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      salary_range_forthisjob: 15000,
      organisation_place:'',
      organisation:'',
      job_role_other_disabled:true,
      job_subject_teaching_other_disabled:true,
      expected_qualification_other_disabled:true,
      examcertifications_other_disabled:true,
      skillsrequired_other_disabled:true
    }

    this.cancelPop = this.cancelPop.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }
 

  componentDidMount() {

          var THIS = this;
  
   

  }


  handleChangeHorizontal = value => {
    this.setState({
      salary_range_forthisjob: value
    })
  };


  cancelPop(){
    this.setState({blockinstopenmodal:false});
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
  handleSubmit =(e) =>{


    let req = JSON.stringify({
         
        blog_title: this.state.blog_title,
        blog_url : this.state.blog_url,
        blog_status : this.state.blog_status 

    })
    
    postanextblog(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Posted successfully', 'Post an external article');

      }else{
            
        NotificationManager.error('Error posting', 'Post an external article');
      }

    });
}
  
 
  render() {
 const {value, suggestions, pickedones} = this.state;
 const { salary_range_forthisjob, vertical } = this.state
    const horizontalLabels = {
      12000: '12k',
      400000: '4L'
    }

    const formatkg = value => value;
 
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                     
                  <h4 class="card-title">External Blog - Add</h4>
                 
                  <div class="postajobform wc">

                        <div class="formgroup end_date_option" id="end_date_option">
                        <label for="exampleInputPassword1">Blog Title </label>
                        <input type="text" class="form-control forminputcls" id="organisation" name="blog_title"   onChange={this.handleChange}/>
                        </div> 


                        <div class="formgroup end_date_option" id="end_date_option">
                        <label for="exampleInputPassword1">Blog External URL </label>
                        <input type="text" class="form-control forminputcls" id="job_title" name="blog_url"   onChange={this.handleChange}/>
                        </div> 


                        <div class="formgroup end_date_option" id="end_date_option">
                        <label for="exampleInputPassword1">Status</label>
                        <select name="blog_status" class="formselectinputcls"  onChange={this.handleChange}> 
                                    <option value="">Select</option>
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                        </select>
                        </div> 



                      <div class="formgroup text-center paddingtop20">
                      <button type="button" name="postablog" class="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
                      </div> 


                    </div>


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Addblog;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/addblog.jsx